module.exports = __webpack_public_path__ + "img/BO.05a3b2d1.png";